import { callPostApi, callDeleteApi, callPutApi, callGetApi } from "./api";

export async function getFaqList(data) {
      try {
            const response = await callPostApi({ url: "faq", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getFaqDetail(faqId) {
      try {
            const response = await callGetApi({ url: "faq/" + faqId });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function createFaq(postData) {
      try {
            const response = await callPostApi({ url: "faq/add", body: postData });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function updateFaq(postData, faqId) {
      try {
            const response = await callPutApi({ url: "faq/" + faqId, body: postData });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function deleteFaq(id) {
      try {
            const response = await callDeleteApi({ url: "faq/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}

